export default function FAQSection() {
  const faqs = [
    {
      q: "O que é o Hoobuy Spreadsheet?",
      a: "O Hoobuy Spreadsheet é uma planilha com milhares de links verificados de produtos do Hoobuy, organizados por categorias como tênis, roupas, bolsas e acessórios. Nossa equipe atualiza os links diariamente e verifica cada produto manualmente antes de adicionar à planilha.",
    },
    {
      q: "Como usar a planilha Hoobuy?",
      a: "Basta acessar nossa planilha, escolher a categoria desejada e clicar no link do produto. Cada link leva diretamente ao produto no Hoobuy, onde você pode verificar detalhes, preços e finalizar a compra. É simples, rápido e completamente em português.",
    },
    {
      q: "Os produtos da planilha são confiáveis?",
      a: "Sim. Verificamos manualmente cada link antes de adicionar à planilha. Conferimos a qualidade das imagens, a reputação do vendedor e a precisão das descrições. Links quebrados ou produtos de baixa qualidade são removidos diariamente.",
    },
    {
      q: "Com que frequência a planilha Hoobuy é atualizada?",
      a: "Atualizamos nossa planilha diariamente. Novos produtos são adicionados, links quebrados são corrigidos e produtos esgotados são removidos. Você sempre encontrará conteúdo fresco e atualizado em nossa planilha.",
    },
    {
      q: "A planilha Hoobuy funciona no Brasil e em Portugal?",
      a: "Sim. Nossa planilha é otimizada para compradores do Brasil e de Portugal. Os links funcionam perfeitamente em ambos os países e nossa equipe fala português nativo, garantindo que todo o conteúdo seja claro e preciso.",
    },
    {
      q: "Preciso pagar para usar a planilha Hoobuy?",
      a: "Não. Nossa planilha é completamente gratuita. Você pode acessar todos os links, categorias e guias sem pagar nada. Nosso objetivo é ajudar a comunidade portuguesa a comprar com segurança e economia.",
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a
      }
    }))
  };

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Perguntas Frequentes
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            Tudo o que você precisa saber sobre nossa planilha Hoobuy
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between px-6 py-5 text-sm md:text-base font-semibold text-foreground-950 list-none">
                {faq.q}
                <i className="ri-add-line text-lg text-foreground-400 group-open:hidden transition-all"></i>
                <i className="ri-subtract-line text-lg text-foreground-400 hidden group-open:block transition-all"></i>
              </summary>
              <div className="px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            Acessar Hoobuy Sheet Agora
          </a>
        </div>
      </div>
    </section>
  );
}